// Public-domain photographs by federal agencies, used behind the home hero.
// Each carries its creator and source so the credit is always reachable.

export type HeroPhoto = {
  file: string
  small: string
  alt: string
  title: string
  creator: string
  source: string
  license: string
}

export type HeroVideo = {
  webm: string
  mp4: string
  poster: string
  title: string
  creator: string
  source: string
  license: string
}

/** A public-domain loop for the video hero. */
export const heroVideo: HeroVideo | null = {
  webm: '/media/hero-loop.webm',
  mp4: '/media/hero-loop.mp4',
  poster: '/media/hero-loop-poster.jpg',
  title: 'Earth Views from the International Space Station',
  creator: 'NASA, ISS High Definition Earth Viewing',
  source: 'https://images.nasa.gov/details/Earth%20Views%20from%20the%20International%20Space%20Station',
  license: 'Public domain (U.S. government work)',
}

export const heroPhotos: HeroPhoto[] = [
  {
    file: "/media/hero-capitol.jpg",
    small: "/media/hero-capitol-sm.jpg",
    alt: "The west front of the United States Capitol under a blue sky.",
    title: "United States Capitol, west front",
    creator: "Architect of the Capitol",
    source: "https://commons.wikimedia.org/wiki/File:United_States_Capitol_-_west_front.jpg",
    license: "Public domain (U.S. government work)",
  },
  {
    file: "/media/hero-grand-canyon.jpg",
    small: "/media/hero-grand-canyon-sm.jpg",
    alt: "Evening light on the buttes and cliffs of the Grand Canyon, seen from Yaki Point on the South Rim.",
    title: "Sunset from Yaki Point, Grand Canyon National Park",
    creator: "Grand Canyon National Park, National Park Service",
    source: "https://commons.wikimedia.org/wiki/File:Grand_Canyon_National_Park,_Sunset_from_Yaki_Point_5207_-_Flickr_-_Grand_Canyon_NPS.jpg",
    license: "Public domain (U.S. government work)",
  },
  {
    file: "/media/hero-lincoln-memorial.jpg",
    small: "/media/hero-lincoln-memorial-sm.jpg",
    alt: "Visitors on the snow-covered National Mall, seen between the columns of the Lincoln Memorial, with the Washington Monument in the distance.",
    title: "View from the Lincoln Memorial in snowfall",
    creator: "Victoria Stauffenberg, National Park Service",
    source: "https://commons.wikimedia.org/wiki/File:Lincoln_Memorial_at_National_Mall_%26_Memorial_Parks_(59ab1ce6-639b-4922-a2cf-a9599730f53f).jpg",
    license: "Public domain (U.S. government work)",
  },
  {
    file: "/media/hero-earthrise.jpg",
    small: "/media/hero-earthrise-sm.jpg",
    alt: "Earth rising above the lunar horizon, photographed from lunar orbit during Apollo 8.",
    title: "Earthrise (Apollo 8, December 24, 1968)",
    creator: "William Anders, NASA",
    source: "https://commons.wikimedia.org/wiki/File:NASA-Apollo8-Dec24-Earthrise.jpg",
    license: "Public domain (U.S. government work)",
  }
]
